export class PreviewOrderCreateDto {
  id: number;
  personalizedMessages: PersonalizedMessage;
}

export class PersonalizedMessage {
  messageFirstLine: string;
  messageSecondLine: string;
}
